"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _search = require("modals/search");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _Overview = require("tab/Overview");

var _class, _descriptor, _descriptor2, _temp;

var PeopleGroupOverviewTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PeopleGroupOverviewTab, _Component);

  function PeopleGroupOverviewTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PeopleGroupOverviewTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PeopleGroupOverviewTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "description", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "people", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PeopleGroupOverviewTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, !!this.description && _react.default.createElement("div", {
        id: "courseDescription"
      }, this.description && _react.default.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      })), this.renderPeople());
    }
  }, {
    key: "renderPeople",
    value: function renderPeople() {
      if (!this.people) return null;
      return _react.default.createElement(_Overview.PeopleList, this.people);
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      if (tab.visible()) {
        var order = tab.order,
            title = tab.title,
            id = tab.id;
        var r = Object.assign({
          type: 'tab/PeopleGroupOverview',
          description: object.lpDescription
        }, this.getPeople(object, page), {
          id: id,
          title: title,
          order: order
        });
        if (r.description || r.people) return r;
      }

      return null;
    }
  }, {
    key: "getPeople",
    value: function getPeople(object, page) {
      var people = _exports.default.Channel.tools.accountGroupPeople.lwp('find', {
        parent: object.id,
        $order: 'parent_index',
        $orderDir: 'asc',
        displayOnSite: 1,
        $getRecordDetails: ['id', 'person', 'title']
      }).records;

      var accounts = _exports.default.Channel.tools.accounts.getRecords(people.map(function (item) {
        return item.person;
      }));

      var r = people.map(function (item) {
        var person = accounts[item.person];
        if (!person) return null;
        return {
          id: person.id,
          link: Number(person.enableLandingPage) ? _exports.default.Link('InstructorDetail', person) : null,
          photo: require('person-image').default(person),
          name: person.nickname || person.fullName,
          icons: require('accounts/icons').default(person),
          title: item.title || person.lpTitle,
          location: person.lpLocation,
          bio: person.shortBio
        };
      });
      if (!r.length) return {};
      return {
        people: {
          title: object.peopleTitle,
          items: r
        }
      };
    }
  }]);
  return PeopleGroupOverviewTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = PeopleGroupOverviewTab;